import TabBar from '../../../component/tab-bar/tab-bar';
import React, { useState } from 'react';
import { WorkingYearsManagement } from './tabs/working-yeas-management/working-years-management';
import { CalendarVacation } from './tabs/calendar-vacation/calendar-vacation';

const tabs = ['לוח חופשות', 'שנות עבודה' /*, 'שרותים', 'היסטוריית רכישות'*/];
export const SettingsTimeManagement = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabSelected = (index: number) => {
    setSelectedIndex(index);
  };

  const elementTabs = [<CalendarVacation />, <WorkingYearsManagement />];

  return (
    <div className={'studies-settings-root'}>
      <div style={{ width: '100%' }} className={'studies-settings-body-page'}>
        <div className={'studies-settings-title'}>
          הגדרות מערכת - מנהל הזמנים
        </div>

        <TabBar
          tabs={tabs}
          onClick={(index) => {
            onTabSelected(index);
            console.log('The index ' + index + 'Is clicked');
          }}
        ></TabBar>

        {elementTabs[selectedIndex]}
      </div>
    </div>
  );
};
